export default "__VITE_ASSET__jz3JUDUu__";